import React from 'react'
import Image from 'next/image'
import { Header2, Text } from '../../styles/Components'
import Partner1Image from '../../../public/about-us/partner-1.jpg'
import Partner2Image from '../../../public/about-us/partner-2.jpg'
import { PartnershipsWrapper } from './styles'

const partnerships = [
  {
    id: 'shark',
    brandName: 'Shark Beauty™',
    role: 'Preferred Tools Partner',
    blurb: 'Prepare to be blown away. We’ve partnered with Shark Beauty™ to bring you flawless blowouts with the ultra-powerful, ultra-compact SpeedStyle™ Pro Flex.',
    image: Partner1Image,
    alt: 'Two Glamsquad models holding the Shark Beauty SpeedStyle Pro Flex hair dryer for at-home blowouts',
  },
  {
    id: 'olaplex',
    brandName: 'OLAPLEX',
    role: 'Preferred Styling Partner',
    blurb: 'We’ve partnered with OLAPLEX to bring a new era of performance styling right to your doorstep. Let’s make your next glam moment a lasting style memory.',
    image: Partner2Image,
    alt: 'Three Glamsquad models with freshly styled hair, one holding a bottle of OLAPLEX styling spray, a Glamsquad styling partner product',
  },
]

const Partnerships = () => (
  <PartnershipsWrapper aria-label="Premier partnerships">
    <Header2 className="section-heading">Premier partnerships</Header2>
    <div className="partnerships-grid">
      {partnerships.map((p) => (
        <div className="partnership-item" key={p.id}>
          <div className="partnership-copy">
            <p className="partnership-name">{p.brandName}</p>
            <p className="partnership-role">{p.role}</p>
            <Text fontSize={16} lineHeight="1.3" spacing={0.16}>{p.blurb}</Text>
          </div>
          <div className="partnership-image">
            <Image
              src={p.image}
              alt={p.alt}
              fill
              style={{ objectFit: 'cover' }}
              sizes="(max-width: 768px) 100vw, 50vw"
            />
          </div>
        </div>
      ))}
    </div>
    <div className="cta-block">
      <Header2 fontSize={32} lineHeight="1.2" align="center" margin="0">
        Want to partner with us?
      </Header2>
      <Text fontSize={16} lineHeight="1.38" spacing={0.16} textAlign="center">
        Reach out to{' '}
        <a href="mailto:partnerships@glamsquad.com" className="partnerships-email">
          partnerships@glamsquad.com
        </a>
      </Text>
    </div>
  </PartnershipsWrapper>
)

export default Partnerships
